// extracted by mini-css-extract-plugin
export default {"app":"App_app__uYiJ0","canvas":"App_canvas__mz-TZ","loadingWrapper":"App_loadingWrapper__MVLe9","loading":"App_loading__irBn8","sidebar":"App_sidebar__PPH0O"};